import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchStationReferential } from '../../../../../core';
import './observation-search.scss';

/**
 * Renders an <ObservationSearch /> component
 * @param {Object} props
 * @param {string} props.className - the className derived from provided props
 * @param {string} props.referential - the referential's name
 * @param {object} props.selectedStation - display the selectedStation
 * @param {function} props.setSelectedStation - set the setSelectedStation

 */
const ObservationSearch = (props) => {
	const { className = '', referential, searchLabel, selectedStation, setSelectedStation, line } = props;
	const { t } = useTranslation();
	
	return (
		<div className={`observation-search ${className}`}>
			{searchLabel && <label className="observation-search__label">{searchLabel}</label>}
			<SearchStationReferential
				className="field__input"
				referential={referential}
				lineStation={line}
				placeholder={t('observation:observation-fields.search-label')}
				selectedStation={selectedStation}
				setSelectedStation={setSelectedStation}
			/>
		</div>
	);
};

ObservationSearch.propTypes = {
	className: PropTypes.string,
	referential: PropTypes.string,
	selectedStation: PropTypes.object,
	setSelectedStation: PropTypes.func,
	line: PropTypes.string,
};

export default ObservationSearch;
